<template>
  <div>
    <el-button type="primary" size="mini" @click="hide">全屏显示/恢复</el-button>
    <el-row>
      <el-col :span="24">
        <el-table border style="font-size: 12px" :data="gaoyaoData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">

          <el-table-column  prop="tid" label="订单号" width="160px"></el-table-column>
          <el-table-column  prop="payTime" label="付款时间" width="160px"></el-table-column>
          <el-table-column  prop="maskNick" label="买家昵称" width="120px"></el-table-column>
          <el-table-column  prop="title" label="商品标题" width="240px"></el-table-column>
          <el-table-column  prop="skuPropertiesName" label="属性" width="200px"></el-table-column>
          <el-table-column  prop="num" label="数量" ></el-table-column>
          <el-table-column  prop="price" label="原价" ></el-table-column>
          <el-table-column  prop="totalFee" label="总价" ></el-table-column>
          <el-table-column  prop="postFee" label="运费" ></el-table-column>
          <el-table-column  prop="sellerMemo" label="备注" ></el-table-column>
          <el-table-column  prop="" label="单号" ></el-table-column>
          <el-table-column  prop="maskName" label="姓名" width="120px"></el-table-column>
          <el-table-column  prop="maskMobile" label="电话" width="120px"></el-table-column>
          <el-table-column  prop="receiverState" label="省" ></el-table-column>
          <el-table-column  prop="receiverCity" label="市" ></el-table-column>
          <el-table-column  prop="receiverDistrict" label="区县" ></el-table-column>
          <el-table-column  prop="address" label="地址"  width="240px"></el-table-column>
          <el-table-column  prop="refundStatus" label="退款状态" ></el-table-column>

        </el-table>
      </el-col>
    </el-row>

    <div class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[5, 10, 20, 50, 100, 5000]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

    export default {
        name: "GaoYao",
      data() {
        return {
          display:1,
          gaoyaoData:[],
          pageObject: {
            pageCurrent: 1,
            rowCount: 0,
            pageSize: 10
          },
        }
      },
      methods:{
        hide:function(){
          this.display++;
          if(this.display % 2 == 0){
            window.document.getElementById("left").style.display = 'none';
            window.document.getElementById("top").style.display = 'none';
          }else {
            window.document.getElementById("left").style.display = 'block';
            window.document.getElementById("top").style.display = 'block';
          }

        },
        indexMethod(index)
        {
          return index + 1;
        },
        getGaoYaoData:function () {
          let param={
            nick: storage.get("nick")
          }
          $api.post("/custom/gaoyao",param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1 && dataResult.message=="ok"){
              this.gaoyaoData = dataResult.data.gaoyao;
              let pageObject = dataResult.data.pageObject;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
            }else{
              this.$message.error(dataResult.message);
              this.$router.replace({name: "Index"});
            }
          })
        }
      },
      mounted(){
        this.getGaoYaoData();
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/GaoYao.vue